import { BirthdateType } from '@api';
import dayjs from 'dayjs';
import 'dayjs/locale/de';

type FormatBirthdateReturnType = string | undefined;

export const formatBirthdate = (
  birthdate: BirthdateType
): FormatBirthdateReturnType => {
  const { month, day, year } = birthdate;

  if (!month || !day) return;

  const date = dayjs()
    .year(year || 2000)
    .month(month - 1)
    .date(day)
    .locale('de');

  if (!date.isValid()) return;

  return year ? date.format('DD.MM.YYYY') : date.format('DD.MM.');
};
